// extracted by mini-css-extract-plugin
export default {"header":"style_header__VVDzK","subheader":"style_subheader__2V5I4","numbers":"style_numbers__X+AFj"};